import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { Timestamp } from 'components/datatable'

const MyLatestViewedWidget = ({widget}) => {
  const mounted = useRef(false);

  const [entries, setEntries] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch(`coordinatordashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setEntries(data.data.entries);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const onClick = (entry) => {
    reactHistory.push({
      order: `/orders/${entry.entry_id}/overview`,
      customer: `/customers/${entry.entry_id}/contact-info`,
      supplier: `/suppliers/${entry.entry_id}/overview`
    }[entry.entry_type])
  };

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <div className="bg-white border shadow rounded border-gray-400" id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="w-full text-xs">
        {entries.map((entry) =>
          <div
              key={`${entry.entry_type}-${entry.entry_id}-${entry.viewed_at}`}
              className="hover:bg-gray-200 flex border-b cursor-pointer group"
              title={entry.entry_type}
              onClick={() => onClick(entry)}
          >
              <div className="shrink-0 px-4 py-2 capitalize w-20">
                  {entry.entry_type}
              </div>
              <div className="grow truncate px-4 py-2 group-hover:text-primary">
                  {entry.entry_name}
              </div>
              <div className="shrink-0 text-right px-4 py-2">
                <Timestamp className="truncate">{entry.viewed_at}</Timestamp>
              </div>
          </div>
        )}
      </div>
    </div>
  );

}

export default MyLatestViewedWidget;
